import type { Enemy } from "../entities/Enemy.ts";

/**
 * Predicate: is this enemy "tanky"? Used by ZERO_DAY_EXPLOIT / COLD_BOOT's
 * boss-damage multiplier (projectile, sniper and beam), GOLD kinetic's
 * execute, and Kernel-Panic's source selection.
 *
 * GA-07 / GA-19 (Spec C+) — reads the AUTHORED archetype from `enemies.json`.
 *
 * The previous implementation compared `enemy.type` against the literals
 * "boss" / "final_boss" / "golem". `Enemy.init` sets `this.type = config.name`,
 * i.e. the DISPLAY name, so those ran against "Core Breaker", "AXIOM-77 Core"
 * and "Rootkit" and could never match. Verified by execution across all 19
 * shipped enemy types: it returned `false` for every single one, both bosses
 * included, so all four call sites were dead in production.
 */
export function isTanky(enemy: Enemy): boolean {
  return enemy.archetype === "tanky";
}
